const KRAJ_BY_PREFIX: Record<string, string> = {
  '01': 'Žilinský kraj',
  '02': 'Žilinský kraj',
  '03': 'Žilinský kraj',
  '04': 'Košický kraj',
  '05': 'Košický kraj',
  '06': 'Prešovský kraj',
  '07': 'Košický kraj',
  '08': 'Prešovský kraj',
  '09': 'Prešovský kraj',
  '81': 'Bratislavský kraj',
  '82': 'Bratislavský kraj',
  '83': 'Bratislavský kraj',
  '84': 'Bratislavský kraj',
  '85': 'Bratislavský kraj',
  '90': 'Trnavský kraj',
  '91': 'Trenčiansky kraj',
  '92': 'Trnavský kraj',
  '93': 'Trnavský kraj',
  '94': 'Nitriansky kraj',
  '95': 'Nitriansky kraj',
  '96': 'Banskobystrický kraj',
  '97': 'Banskobystrický kraj',
  '98': 'Banskobystrický kraj',
};

const KRAJ_ORDER: Record<string, number> = {
  'Bratislavský kraj': 1,
  'Trnavský kraj': 2,
  'Trenčiansky kraj': 3,
  'Nitriansky kraj': 4,
  'Žilinský kraj': 5,
  'Banskobystrický kraj': 6,
  'Prešovský kraj': 7,
  'Košický kraj': 8,
};

const normalizePsc = (pc: string): string => pc.replace(/\s+/g, '');

export const postCodeToKraj = (pc: string | null | undefined): string | null => {
  if (!pc) return null;
  return KRAJ_BY_PREFIX[normalizePsc(pc).slice(0, 2)] ?? null;
};

export const KRAJE = [
  'Bratislavský kraj',
  'Trnavský kraj',
  'Trenčiansky kraj',
  'Nitriansky kraj',
  'Žilinský kraj',
  'Banskobystrický kraj',
  'Prešovský kraj',
  'Košický kraj',
];

export const prefixesForKraj = (kraj: string): string[] =>
  Object.entries(KRAJ_BY_PREFIX)
    .filter(([, k]) => k === kraj)
    .map(([prefix]) => prefix);

export const krajOrderIndex = (kraj: string | null): number =>
  kraj === null ? 99 : (KRAJ_ORDER[kraj] ?? 99);
